<template>
	<div>
		<v-card flat color="transparent">
			<v-card-text>
				<v-row align="center">
					<v-col cols="12" md="4">
						<v-text-field solo flat outlined dense v-model="tableProps.search" label="Buscar..." clearable append-icon="mdi-magnify" hide-details></v-text-field>
					</v-col>
					<v-spacer></v-spacer>
					<v-col cols="12" md="2" class='flexbox-right' v-permission="'clients.create'">
						<v-btn class='btn-yellow' elevation="0" block to="/clientes/registro" tile>
                            Nuevo cliente
                            <v-icon
                                class="ml-2"
                                color=""
                            >
                                mdi-plus
                            </v-icon>
                        </v-btn>
					</v-col>
				</v-row>
				<v-row>
					<v-col>
						<datatable :props="tableProps" @method_handler="method_handler"></datatable>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

        <modal :props="modalProps" @modalResponse="method_handler"></modal>

	</div>
</template>

<script>
export default {
	data(){
		return {
			actions: [
				{
					name: 'Detalle',
					icon: {
						color: 'secondary',
						icon: 'mdi-information'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '/clientes/1/detalles',
                    permissions: 'clients.show'
				},
				{
					name: 'Editar',
					icon: {
						color: 'secondary',
						icon: 'mdi-pencil'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '/clientes/1/edicion',
                    permissions: 'clients.update'
				},
				{
					name: 'Borrar',
					icon: {
						color: 'secondary',
						icon: 'mdi-delete'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'removeRecord',
                    permissions: 'clients.delete'
				},
			],
			tableProps: {
				headers: [
                    {
                        text: 'ID',
                        align: 'left',
                        value: 'sku',
                        class: 'primary--text text-uppercase'
                    },
                    {
                        text: 'Nombre',
                        align: 'left',
                        value: 'name',
                        class: 'primary--text text-uppercase'
                    },
                    {
                        text: 'Estado',
                        align: 'center',
                        value: 'state',
                        class: 'primary--text text-uppercase'
                    },
                    {
                        text: 'Contacto',
                        align: 'center',
                        value: 'contact',
                        class: 'primary--text text-uppercase'
                    },
                    {
                        text: 'Teléfono',
                        align: 'center',
                        value: 'phone',
                        class: 'primary--text text-uppercase'
                    },
                    {
                        text: 'Acciones',
                        align: 'right',
                        sortable: false,
                        value: 'actions',
                        class: 'primary--text text-uppercase'
                    }
				],
				items: [],
				search: ''
			},
			modalProps: {
				visible: false,
				width: '500',
				title: 'Hola',
				text: 'Adiós',
				buttons: [
					{
						text: 'Cancelar',
						color: 'error',
						textColor: 'white',
						btnTypeText: true,
						method: 'cancel',
						parameters: []
					},
					{
						text: 'Aceptar',
						color: 'secondary',
						textColor: 'primary--text mx-1',
						btnTypeText: false,
						method: 'confirm',
						parameters: []
					}
				]
			},
			countries: []
		}
	},
	mounted(){
		this.getCountries()
		this.index()
	},
	methods: {
		method_handler(object){
			this[object.method_name](object.parameters)
		},
		getCountries(){
			this.$http.get(this.$store.state.countryApiRoute+'/api/getCountries')
			.then((response) => {
				this.countries = response.data
			})
			.catch((error) => {
				error
			})
		},
		index(){
			this.$store.state.overlay = true
			
			this.$http.get(this.$store.state.apiRoute+'/clients')
			.then((response) => {
				this.tableProps.items = response.data.map((x) => {
					x['country'] = '-'
					x['state'] = '-'
					// x.address_code = 'ST-SLP'
					if(x.address_code != null){
						const type = x.address_code.substring(0, 2)
						const code = x.address_code.substring(3)
						
						switch(type){
							case "CT":
								this.$http.get(this.$store.state.countryApiRoute+'/api/getCityDetails/'+code)
								.then((response) => { 
									x['country'] = response.data.country.name.common; 
									x['state'] = response.data.state.name
								})
							break;
							case "ST":
								this.$http.get(this.$store.state.countryApiRoute+'/api/getStateDetails/'+code)
								.then((response) => { 
									x['country'] = response.data.country.name.common; 
									x['state'] = response.data.state.name
								})
							break;
							case "CY":
							break;
						}
					}
					x['actions'] = JSON.parse(JSON.stringify(this.actions))

					x.actions[0].action = { name: 'ClientesDetalles', params: { id: x.slug } }
					x.actions[1].action = { name: 'ClientesEdicion', params: { id: x.slug } }
					
					x['parameters'] = { id: x.slug }

					return x
				})
			})
			.catch(error => {
				error
			})
			.finally(() => {
				this.$store.state.overlay = false
			})
		},
		removeRecord(parameters){
			// eslint-disable-next-line no-console
			console.log(parameters)
			this.modalProps = {
				visible: true,
				width: '500',
				title: 'Eliminar cliente',
				text: '¿Desea continuar?',
				buttons: [
					{
						text: 'Cancelar',
						color: 'primary',
						textColor: 'white',
						btnTypeText: true,
						method: 'cancel',
						parameters: {}
					},
					{
						text: 'Aceptar',
						color: 'secondary',
						textColor: 'text-base-color mx-1',
						btnTypeText: false,
						method: 'confirm',
						parameters: {
							id: parameters.id
						}
					}
				]
			}
			this.modalProps.visible = true
		},
		confirm(parameters){
			this.$http.delete(this.$store.state.apiRoute+'/clients/'+parameters.id+'/delete')
			.then(() => {
				this.snackbar = {
					visible: true,
					color: 'green',
					text: 'Se eliminó el cliente',
					timeout: 3000
				}
				this.index()
			}).catch(error => {
                console.error(error);
				this.snackbar = {
					visible: true,
					color: 'red',
					text: 'Error al eliminar. Intenta de nuevo',
					timeout: 3000
				}
			})
			.finally(() => {
				this.modalProps.visible = false
			})
		},
		cancel(){
			this.modalProps.visible = false
		}
	},
}
</script>

<style>

</style>